exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#loading{font-size:12px;font-weight:400;color:#00ffd5;text-align:center;line-height:2.4;letter-spacing:1.4px}#loading.index{padding-top:23px}#loading.single{padding-top:9px;border-top:1px solid #e0e0e0}#loading span{animation:blink-loading .18s step-end infinite}#container.theme_b #loading.index{position:absolute;width:100%;left:0}@keyframes blink-loading{50%{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/Loading.less
// module id = 200
// module chunks = 0